import { motion } from 'framer-motion';
import ReactMarkdown from 'react-markdown';

interface ScriptFullViewProps {
  content: string;
}

export function ScriptFullView({ content }: ScriptFullViewProps) {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
    >
      <div className="rounded-2xl bg-slate-900/50 backdrop-blur-xl border border-slate-700/50 p-6 md:p-8">
        <div className="prose prose-invert prose-sm max-w-none prose-headings:text-slate-100 prose-p:text-slate-300 prose-strong:text-slate-200 prose-li:text-slate-300 prose-hr:border-slate-700/50">
          <ReactMarkdown>{content}</ReactMarkdown>
        </div>
      </div>
    </motion.div>
  );
}
